// extracted by mini-css-extract-plugin
export default {"facebookLogin":"FacebookButton_facebookLogin__fI2V7"};